import { ITaggingFlowOption } from 'interfaces/tagging/ITaggingFlowOption';
import { ResultTypes } from '@trackman/baseball-shared-components';

export const InPlayResultOptions: ITaggingFlowOption[] = [
  {
    displayName: 'Out',
    value: ResultTypes.Out,
    hotkeyCode: 79,
    hotkeyDisplay: 'O',
  },
  {
    displayName: 'Single',
    value: ResultTypes.Single,
    hotkeyCode: 49,
    hotkeyDisplay: '1',
  },
  {
    displayName: 'Double',
    value: ResultTypes.Double,
    hotkeyCode: 50,
    hotkeyDisplay: '2',
  },
  {
    displayName: 'Triple',
    value: ResultTypes.Triple,
    hotkeyCode: 51,
    hotkeyDisplay: '3',
  },
  {
    displayName: 'HomeRun',
    value: ResultTypes.Homerun,
    hotkeyCode: 72,
    hotkeyDisplay: 'H',
  },
  {
    displayName: 'Error',
    value: ResultTypes.Error,
    hotkeyCode: 69,
    hotkeyDisplay: 'E',
  },
  {
    displayName: 'Fielders Choice',
    value: ResultTypes.FieldersChoice,
    hotkeyCode: 70,
    hotkeyDisplay: 'F',
  },
  {
    displayName: 'Sacrifice',
    value: ResultTypes.Sacrifice,
    hotkeyCode: 83,
    hotkeyDisplay: 'S',
  },
];
